import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full';

// Views
import ErrorPage from '@/views/ErrorPage';
import Home from '@/views/Home';
import ManageGroupUser from '@/views/Manage/GroupUser';
import ManageListUser from '@/views/Manage/ListUser';
import ManageAudit from '@/views/Manage/Audit';
import ManageNews from '@/views/Manage/News';
import ManageSMS from '@/views/Manage/SMS';
import ManageFeedback from '@/views/Manage/Feedback';
import AnalyzeRain from '@/views/Analyze/Rain';
import AnalyzeFlood from '@/views/Analyze/Flood';
import AnalyzeFloodData from '@/views/Analyze/FloodData';
import AnalyzeStatistic from '@/views/Analyze/Statistic';
import AnalyzeSensingImage from '@/views/Analyze/SensingImage';
import Report from '@/views/Analyze/Report';
import Station from '@/views/Database/Station';
import Configuration from '@/views/Database/Configuration';
import Category from '@/views/Database/Category';
import Layer from '@/views/Database/Layer';
import File from '@/views/Database/File';
import Maps from '@/views/Public/Maps';
import About from '@/views/Public/About';
import MapMobile from '@/views/Public/MapMobile';
import News from '@/views/Public/News';
import NewsDetail from '@/views/Public/NewsDetail';
import DashBoard from '@/views/Public/DashBoard';
import Feedback from '@/views/Public/Feedback';
import Document from '@/views/Public/Document';
import AllNews from '@/views/Public/AllNews';

// VueX store
import store from '@/store';

Vue.use(Router);

// Before enter functions
const ifAuthenticated = async (to, from, next) => {
    if (store.getters['auth/isAuthenticated']) {
        next();
        return;
    }
    next('/home');
};

export default new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    routes: [
        {
            path: '*',
            name: 'ErrorPage',
            component: ErrorPage
        },
        {
            path: '/',
            redirect: '/home',
            component: Full,
            children: [
                {
                    path: 'home',
                    name: 'Home',
                    component: Home
                },

                {
                    path: 'maps',
                    name: 'Maps',
                    component: Maps
                },

                {
                    path: 'maps-mobile',
                    name: 'Maps Mobile',
                    component: MapMobile
                },

                {
                    path: 'dashboard',
                    name: 'DashBoard',
                    component: DashBoard
                },

                {
                    path: 'about',
                    name: 'About',
                    component: About
                },

                {
                    path: 'news',
                    name: 'routes.news',
                    redirect: '/news',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: '',
                            name: 'ListNews',
                            component: News
                        },
                        {
                            path: ':id(\\d+)',
                            name: 'NewsDetail',
                            component: NewsDetail
                        }
                    ]
                },

                {
                    path: 'document',
                    name: 'Document',
                    component: Document
                },

                {
                    path: 'all-news',
                    name: 'AllNews',
                    component: AllNews
                },

                {
                    path: 'feedback',
                    name: 'Feedback',
                    component: Feedback
                },

                // System view
                {
                    path: 'system',
                    name: 'System',
                    redirect: '/system/sms',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'sms',
                            name: 'ManageSMS',
                            component: ManageSMS,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'feedback',
                            name: 'ManageFeedback',
                            component: ManageFeedback,
                            beforeEnter: ifAuthenticated
                        }
                    ]
                },

                // User view
                {
                    path: 'user',
                    name: 'User',
                    redirect: '/user/group',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'group',
                            name: 'Group User',
                            component: ManageGroupUser,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'user',
                            name: 'List Users',
                            component: ManageListUser,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'logs',
                            name: 'Audit',
                            component: ManageAudit,
                            beforeEnter: ifAuthenticated
                        }
                    ]
                },

                // Database view
                {
                    path: 'database',
                    name: 'Database',
                    redirect: '/database/stations',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'stations',
                            name: 'Stations',
                            component: Station,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'configurations',
                            name: 'Configurations',
                            component: Configuration,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'categories',
                            name: 'Categories',
                            component: Category,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'layers',
                            name: 'Layer',
                            component: Layer,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'files',
                            name: 'File',
                            component: File,
                            beforeEnter: ifAuthenticated
                        }
                    ]
                },

                // Analyze
                {
                    path: 'analyze',
                    name: 'Analyze',
                    redirect: '/analyze/flood',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'flood',
                            name: 'Flood',
                            component: AnalyzeFlood,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'rain',
                            name: 'Rain',
                            component: AnalyzeRain,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'report',
                            name: 'Report',
                            component: Report,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'report-data',
                            name: 'AnalyzeStatistic',
                            component: AnalyzeStatistic,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'flood-image',
                            name: 'AnalyzeFloodData',
                            component: AnalyzeFloodData,
                            beforeEnter: ifAuthenticated
                        },
                        {
                            path: 'sensing-image',
                            name: 'AnalyzeSensingImage',
                            component: AnalyzeSensingImage,
                            beforeEnter: ifAuthenticated
                        }
                    ]
                },

                // News view
                {
                    path: 'news',
                    name: 'Manage News',
                    redirect: '/news/manage-news',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'manage-news',
                            name: 'ManageNews',
                            component: ManageNews,
                            beforeEnter: ifAuthenticated
                        }
                    ]
                }
            ]
        }
    ]
});
